import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import styles from "./styles.module.css";

const StepsIndicator = ({ activeStep = 1 }) => {
  const steps = [
    { number: 1, label: "Base Resumo" },
    // { number: 2, label: "Base de Crédito" }, // Etapa removida
    { number: 2, label: "Base Legal" }, // Ajustado de 3 para 2
  ];

  const getStepClass = (stepNumber) => {
    if (stepNumber === activeStep) {
      return `${styles.step} ${styles.activeStep}`;
    }
    if (stepNumber < activeStep) {
      return `${styles.step} ${styles.completedStep}`;
    }
    return styles.step;
  };

  const isCompleted = (stepNumber) => {
    return stepNumber < activeStep;
  };

  return (
    <div className={styles.steps}>
      {steps.map((step, index) => (
        <div key={step.number} className={getStepClass(step.number)}>
          <span className={styles.stepNumber}>
            {isCompleted(step.number) ? (
              <CheckIcon className={styles.checkIcon} />
            ) : (
              step.number
            )}
          </span>
          <span className={styles.stepLabel}>{step.label}</span>
        </div>
      ))}
    </div>
  );
};

export default StepsIndicator;

